export const BANNER_STATUS = {
  INFO: 'info',
  ALERT: 'alert',
  WARNING: 'warning'
};
